import { useForm } from "react-hook-form";
import { z } from "zod";
import { zodResolver } from "@hookform/resolvers/zod";
import { Button } from "@/components/ui/button";
import {
  Form,
  FormControl,
  FormDescription,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

const brandFormSchema = z.object({
  name: z.string().min(1).max(255),
  mission: z.string().min(1).max(500),
  homepage: z.string().url(),
});

export interface BrandFormV2Props {
  onSubmit: (values: z.infer<typeof brandFormSchema>) => void;
}

export const BrandFormV2 = ({ onSubmit }: BrandFormV2Props): JSX.Element => {
  const form = useForm<z.infer<typeof brandFormSchema>>({
    resolver: zodResolver(brandFormSchema),
    defaultValues: {
      name: "",
      mission: "",
      homepage: "",
    },
  });

  return (
    <Form {...form}>
      <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-3">
        <FormField
          control={form.control}
          name="name"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Brand Name</FormLabel>
              <FormControl>
                <Input placeholder="Marketer AI" {...field} />
              </FormControl>
              <FormDescription>This is the name of your brand.</FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="mission"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Mission</FormLabel>
              <FormControl>
                <Input
                  placeholder="To make marketing easy for everyone"
                  {...field}
                />
              </FormControl>
              <FormDescription>
                This is the mission of your brand.
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />

        <FormField
          control={form.control}
          name="homepage"
          render={({ field }) => (
            <FormItem>
              <FormLabel>Homepage</FormLabel>
              <FormControl>
                <Input placeholder="https://marketer.ai" {...field} />
              </FormControl>
              <FormDescription>
                This is the homepage of your brand, we'll use this to learn more
                about what you do so we can target the content to your audience.
              </FormDescription>
              <FormMessage />
            </FormItem>
          )}
        />

        <Button type="submit">Submit</Button>
      </form>
    </Form>
  );
};
